module.exports = __webpack_public_path__ + "img/h-works1200x600white.a5e93905.svg";